import { LOCALE_ID, NgModule } from '@angular/core';
import localeRu from '@angular/common/locales/ru';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule } from '@angular/router';
import { FuseModule } from '../@fuse';
import { FuseConfigModule } from '../@fuse/services/config/config.module';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from './core/core.module';
import { appConfig } from './core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import '@angular/common/locales/global/ru';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './app.state';
import { metaReducers } from './store/meta-reducers';
import { AllEffects } from './store/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { QuillModule } from 'ngx-quill';
import { MetrikaModule } from 'ng-yandex-metrika';
import { environment } from '../environments/environment';
import { SocketIoService } from './shared/services/socket.io.service';

registerLocaleData(localeRu);

const routerConfig: ExtraOptions = {
  // preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
  // relativeLinkResolution: 'legacy'
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),
    // Store
    StoreModule.forRoot(appReducers, {
      metaReducers,
    }),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router', // имя ключа состояния роутера в Store (по умолчанию 'router')
    }),
    EffectsModule.forRoot([
      ...AllEffects
    ]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false }), // Опционально: DevTools

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    QuillModule.forRoot(),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    MetrikaModule.forRoot([
      {
        id: environment.metrikaID,
        webvisor: true
      }
    ]),

  ],
  bootstrap: [AppComponent],
  providers: [
    SocketIoService,
    {
      provide: LOCALE_ID,
      useValue: 'ru-RU'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
  ]
})
export class AppModule {}
